/* eslint-disable */
const FOCUSABLE_ELEMENTS = 'button, [href], input, select, textarea, [tabindex]';

class FocusEligibilityFinder {
  constructor(options = { requireTabEligible: false }) {
    this.options = options;
    this.focusEligibleElements = FOCUSABLE_ELEMENTS;
  }

  findFrom($element) {
    const { requireTabEligible } = this.options;

    let $focusableElements = this.findFocusEligibleChildren($element);

    if (requireTabEligible) {
      $focusableElements = $focusableElements.filter(($el) => this.elementTabEligible($el));
    }

    // If $element has no focusable children, assume the $element is what needs to be focused
    if ($focusableElements.length !== 0) {
      // do nothing
    } else if (this.elementEligible($element)) {
      $focusableElements = [$element];
    } else {
      $focusableElements = [];
    }

    return $focusableElements;
  }

  findFocusEligibleChildren($element) {
    const { focusEligibleElements } = this;
    return [...$element.querySelectorAll(focusEligibleElements)];
  }

  elementEligible($element) {
    const { requireTabEligible } = this.options;

    if (requireTabEligible) {
      return this.elementTabEligible($element);
    }
    return this.elementFocusEligible($element);
  }

  elementFocusEligible($element) {
    return $element.matches(FOCUSABLE_ELEMENTS);
  }

  elementTabEligible($element) {
    return this.elementFocusEligible($element) && $element.getAttribute('tabindex') !== '-1' && $element.getAttribute('type') !== 'hidden';
  }
}

export { FocusEligibilityFinder };
